import React from 'react';
import Layout from '../../components/Layout';
import Business from './Business';

const title = 'BestHand for Business — Trusted Pros for Your Properties';
const description =
  'BestHand for Business: vetted pros, one account for multiple sites, consolidated billing and priority support for offices, property managers, landlords and small businesses.';

function action() {
  return {
    title,
    description,
    component: (
      <Layout>
        <Business />
      </Layout>
    ),
  };
}

export default action;
